import { type Automation } from '~/hooks/queries/automations/usePrivateAutomationsList';

/** Latest run outcome when the API adds it to list rows (not in SDK 10.536.0). */
export type AutomationListExtension = {
  lastRunStatus?: 'completed' | 'failed' | 'skipped' | 'started' | null;
};

export type AutomationDetailFields = Automation & AutomationListExtension;

export const UNTITLED_AUTOMATION_LABEL = 'Untitled';

export const readAutomationTitle = (automation: AutomationDetailFields | undefined): string | undefined =>
  automation?.title?.trim() || undefined;

export const readAutomationDescription = (automation: AutomationDetailFields | undefined): string =>
  automation?.description?.trim() ?? '';

export const formatAutomationDisplayTitle = (automation: AutomationDetailFields | undefined): string =>
  readAutomationTitle(automation) ?? UNTITLED_AUTOMATION_LABEL;
